<app-dialog
    [config]="data.config"
    (actionButtonClicked)="onFormSubmit($event)"
>
    <ng-container dialog-title>
        <i class="fa fa-tag mr-2 text-secondary"></i>
        {{ data.isAddNew ? 'Add' : 'Update' }} Price
    </ng-container>

    <ng-container
        *ngIf="form && form.formGroup"
        dialog-process-in-progress
    >
        <form [formGroup]="form.formGroup">
            <div [ngClass]="{'mb-3': form.controls[0].errors.length > 0}">
                <app-datepicker
                    [control]="form.controls[0]"
                    [formControlName]="form.controls[0].name"
                ></app-datepicker>
            </div>
            <div
                *ngIf="form.controls[1]"
                [ngClass]="{'mb-3': form.controls[1].errors.length > 0}"
            >
                <app-amount-input
                    [control]="form.controls[1]"
                    [formControlName]="form.controls[1].name"
                ></app-amount-input>
            </div>
            <div
                *ngIf="form.controls[2]"
                [ngClass]="{'mb-3': form.controls[2].errors.length > 0}"
            >
                <app-amount-input
                    [control]="form.controls[2]"
                    [formControlName]="form.controls[2].name"
                ></app-amount-input>
            </div>
            <div
                *ngIf="form.controls[3]"
                [ngClass]="{'mb-3': form.controls[3].errors.length > 0}"
            >
                <app-amount-input
                    [control]="form.controls[3]"
                    [formControlName]="form.controls[3].name"
                ></app-amount-input>
            </div>
            <div
                *ngIf="form.controls[4]"
                [ngClass]="{'mb-3': form.controls[4].errors.length > 0}"
            >
                <app-amount-input
                    [control]="form.controls[4]"
                    [formControlName]="form.controls[4].name"
                ></app-amount-input>
            </div>
            <div
                *ngIf="form.controls[5]"
                [ngClass]="{'mb-3': form.controls[5].errors.length > 0}"
            >
                <app-amount-input
                    [control]="form.controls[5]"
                    [formControlName]="form.controls[5].name"
                ></app-amount-input>
            </div>
            <div
                *ngIf="form.controls[6]"
                [ngClass]="{'mb-3': form.controls[6].errors.length > 0}"
            >
                <app-amount-input
                    [control]="form.controls[6]"
                    [formControlName]="form.controls[6].name"
                ></app-amount-input>
            </div>
            <div
                *ngIf="form.controls[7]"
                [ngClass]="{'mb-3': form.controls[7].errors.length > 0}"
            >
                <app-amount-input
                    [control]="form.controls[7]"
                    [formControlName]="form.controls[7].name"
                ></app-amount-input>
            </div>
        </form>
    </ng-container>
</app-dialog>
